import { render, staticRenderFns } from "./ConfirmInvite.vue?vue&type=template&id=79be22f5&scoped=true&"
import script from "./ConfirmInvite.vue?vue&type=script&lang=js&"
export * from "./ConfirmInvite.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmInvite.vue?vue&type=style&index=0&id=79be22f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79be22f5",
  null
  
)

export default component.exports